<template>
    <div ref="carousel-container" >         
        <b-carousel 
            id="carousel-1"
            v-model="slide"
            :interval="4000"                        
            indicators
            background="#ababab" 
            style="text-shadow: 1px 1px 2px #333;"
            @sliding-start="onSlideStart"
            @sliding-end="onSlideEnd">
                <!-- Text slides with image -->
                <b-carousel-slide 
                    v-for="(slide, index) in slides"
                    :key="index"
                    :img-src="slide" >
                </b-carousel-slide>                
            </b-carousel>        
    </div>
</template>

<script>
export default {
    props: [
        'slides'
    ],
    data()
    {
        return {
            slide: 0,
        };
    },
    methods: {
        onSlideStart() 
        {

        },

        onSlideEnd() 
        {

        },
    },
    mounted(){
        this.$nextTick(() => {
           //let carouselContainer = this.$refs["carousel-container"];
          // this.height = carouselContainer.clientWidth * (3/4)
        })     
    }
}
</script>
<style scoped>
</style>
